import { render, staticRenderFns } from "./getCodeBtn.vue?vue&type=template&id=4931c0d0&scoped=true"
import script from "./getCodeBtn.vue?vue&type=script&lang=js"
export * from "./getCodeBtn.vue?vue&type=script&lang=js"
import style0 from "./getCodeBtn.vue?vue&type=style&index=0&id=4931c0d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4931c0d0",
  null
  
)

export default component.exports